export {slugify} from "@repo/ui/gailgpt/skills";

// Case-insensitive, numeric-aware alphabetical compare
export function compareAlpha(
  a: string | null | undefined,
  b: string | null | undefined,
  locale?: string | string[],
  options?: Intl.CollatorOptions
): number {
  return (a ?? "").localeCompare(b ?? "", locale, {
    sensitivity: "base",
    numeric: true,
    ...options,
  });
}

/**
 * Converts a human-readable string to snake_case.
 * Handles spaces, camelCase boundaries, hyphens, and collapses repeated underscores.
 *
 * @example toSnakeCase("Phone Number") → "phone_number"
 * @example toSnakeCase("callBackTime") → "call_back_time"
 */
export function toSnakeCase(str: string): string {
  if (!str) return "";

  return str
    .trim()
    .replaceAll(/([a-z\d])([A-Z])/g, "$1_$2")
    .replaceAll(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .replaceAll(/[\s-]+/g, "_")
    .replaceAll(/_+/g, "_")
    .replace(/^_/, "")
    .replace(/_$/, "")
    .toLowerCase();
}

/**
 * Formats identifier strings (snake_case, kebab-case, camelCase) as Title Case labels.
 * For dotted paths (e.g. "data.output"), uses only the last segment.
 *
 * @example formatIdentifierLabel("call_back_time_requested") → "Call Back Time Requested"
 * @example formatIdentifierLabel("responseBody") → "Response Body"
 */
export function formatIdentifierLabel(identifier: string): string {
  if (!identifier) return "";

  const segment = identifier.includes(".") ? identifier.split(".").pop()! : identifier;

  const spaced = segment
    .replaceAll(/[-_]+/g, " ")
    .replaceAll(/\s+/g, " ")
    .trim()
    .replaceAll(/([a-z\d])([A-Z])/g, "$1 $2")
    .replaceAll(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");

  return spaced
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
